import React from 'react';
import { connect } from 'react-redux';

import NewsComponent from '../components/app/News/News';

import * as actions from '../actions/news';

const News = (props) => {
  return (
    <NewsComponent {...props} />
  );
};

export default connect(({ news }) => news, actions)(News);
